// Shared colour / label decision for validation-check verdicts (Coverage,
// Regression). NOT_APPLICABLE means no labeled samples were scored, so the
// check did not run: it renders neutral grey and never shows a percentage.

export const isNotApplicable = (verdict) => verdict === 'NOT_APPLICABLE';

// Text colour, background and border for a verdict; borderAlpha differs per call site.
export function verdictColors(verdict, borderAlpha) {
  if (isNotApplicable(verdict)) {
    return { color: '#94a3b8', bg: 'rgba(148,163,184,0.08)', border: `rgba(148,163,184,${borderAlpha})` };
  }
  if (verdict === 'PASS') {
    return { color: '#10b981', bg: 'rgba(16,185,129,0.08)', border: `rgba(16,185,129,${borderAlpha})` };
  }
  return { color: '#ef4444', bg: 'rgba(239,68,68,0.08)', border: `rgba(239,68,68,${borderAlpha})` };
}

// "PASS (90%)" for PASS/FAIL, bare "NOT_APPLICABLE" otherwise.
export function verdictScoreText(verdict, score) {
  return isNotApplicable(verdict) ? verdict : `${verdict} (${Math.round((score || 0) * 100)}%)`;
}
